import { z } from "zod";
import { env, loadRuntimeConfig } from "@/config/env";
import { usePreferencesStore } from "@/stores/preferences.store";

/**
 * 应用启动序列：
 * 1. 关闭 Zod JIT，避免触发 CSP `script-src` 对 `new Function` 的拦截
 * 2. 启动 MSW（dev / 且 flag 打开）
 * 3. 应用 localStorage 偏好到 <html>（theme 的 `.dark` class / lang）
 *
 * 会话由 edge-gateway 的 HttpOnly `sid` cookie 维护；无需预热 token。
 * 首次受保护路由进入时 requireAuth 会调用 /auth/me 校验 cookie。
 */
export async function bootstrap() {
  await loadRuntimeConfig();
  z.config({ jitless: true });

  if (env.IS_DEV && env.ENABLE_MOCK) {
    const { worker } = await import("@/mocks/browser");
    await worker.start({
      onUnhandledRequest: "bypass",
      serviceWorker: { url: "/mockServiceWorker.js" },
    });
  }

  const prefs = usePreferencesStore.getState();
  const html = document.documentElement;
  const dark =
    prefs.theme === "dark" ||
    (prefs.theme === "system" && window.matchMedia("(prefers-color-scheme: dark)").matches);
  html.classList.toggle("dark", dark);
  html.setAttribute("lang", prefs.language);
}
